function updateGradientFromTwoCols() {
    const colStart = document.querySelector('.delay-menu-left');
    const colEnd = document.querySelector('.delay-menu'); // rightmost column
    const bg = document.querySelector('.px-offcanvas-2-area .offcanvas-bg');

    if (!colStart || !colEnd || !bg) return;

    const viewportWidth = window.innerWidth;

    if (viewportWidth < 768) {
        bg.style.background = '';
        return;
    }

    // get right edge of colEnd relative to viewport
    const colEndRect = colEnd.getBoundingClientRect();
    const endPx = colEndRect.left + colEndRect.width;
    let percent = 0;
    // calculate percentage relative to viewport width
    if (viewportWidth < 992) {
        percent = Math.min(100, (endPx / viewportWidth) * 70);
    } else if (viewportWidth < 1200) {
        percent = Math.min(100, (endPx / viewportWidth) * 60);
    }else{
        percent = Math.min(100, (endPx / viewportWidth) * 70);
    }
    bg.style.background = `
    linear-gradient(
      to right,
      var(--tp-common-px-black) 0%,
      var(--tp-common-px-black) ${percent}%,
      #26282E ${percent}%,
      #26282E 100%
    )
  `;
}

window.addEventListener('load', updateGradientFromTwoCols);
window.addEventListener('resize', () => {
    clearTimeout(window.gradientResizeTimer);
    window.gradientResizeTimer = setTimeout(updateGradientFromTwoCols, 50);
});